<template>
    <div class="arrowsChange">
        <span :class="{'top': true, 'top-on': num === 0}"></span>
        <span :class="{'bottom': true, 'bottom-on': num === 1}"></span>
    </div>
</template>

<script >
export default {
    name: 'arrowsChange',
    data () {
        return {
        }
    },
    props: {
        num: {
            type: [String, Number],
            default: ''
        }
    },
    methods: {
    },
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variables'
.arrowsChange
  vertical-align top
  display inline-block
  span
    display block
  span:first-child
    margin-bottom 4px
  .top
    width 0
    height 0
    border-style solid
    border-width 0 8px 10px 8px
    border-color transparent transparent #999999 transparent
  .top-on
    border-color transparent transparent #fc2d2d transparent
  .bottom
    width 0
    height 0
    border-style solid
    border-width 10px 8px 0 8px
    border-color #999999 transparent transparent transparent
  .bottom-on
    border-color #fc2d2d transparent transparent transparent
</style>
